

const Simmer = () =>{
    return(
        <div className="simmerContainer mt-16  flex flex-wrap md:ml-[0px] w-full  space-x-3 space-y-3">
            <div className="simmerCard p-4 w-[300px] h-[160px] rounded-xl bg-gray-200"></div>
            <div className="simmerCard p-4 w-[300px] h-[160px] rounded-xl bg-gray-200"></div>
            <div className="simmerCard p-4 w-[300px] h-[160px] rounded-xl bg-gray-200"></div>
            <div className="simmerCard p-4 w-[300px] h-[160px] rounded-xl bg-gray-200"></div>
            <div className="simmerCard p-4 w-[300px] h-[160px] rounded-xl bg-gray-200"></div>
            <div className="simmerCard p-4 w-[300px] h-[160px] rounded-xl bg-gray-200"></div>
            <div className="simmerCard p-4 w-[300px] h-[160px] rounded-xl bg-gray-200"></div>
        </div>
    );
};


export default Simmer;